import {webClient} from "../../config/axios";

export const deleteReportRequest = (list) => {
    let deletePromises = []
    list.forEach((downloadId)=>{
        deletePromises.push(webClient.delete(`/report/${downloadId}`))
    })
    return deletePromises;
};